import axios from '@/http/apiRequest';

// 首页主机信息
export const vhostInfo = () => {
  return axios.request({
    method: "POST",
    url: '/api/vhost/info'
  })
};

// 获取首页主机磁盘占用
export const vhostUsedSpace = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/usedSpace'
    })
};

// 首页重启主机
export const vhostRestart = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/restart'
    })
};
  
// 首页开启主机
export const vhostOpen = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/open'
    })
};

// 首页关闭主机
export const vhostClose = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/close'
    })
};

// 首页ftp
export const vhostFtpchange = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/ftp/change'
    })
};

// 首页临时网站
export const vhostApply = () => {
    return axios.request({
        method: "GET",
        url: '/api/ts/apply'
    })
};


// 首页已绑定域名状态
export const queryBindDomainStatus = () => {
    return axios.request({
        method: "POST",
        url: '/api/domain/queryBindDomainStatus'
    })
};

// 查询备案日志
export const queryIcpList = () => {
    return axios.request({
        method: "POST",
        url: '/api/icp/queryIcpList'
    })
};
// ftp重置密码
export const ftpChangePwd = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/changePwd',
        data
    })
};


// 获取mime配置
export const queryMimeConfig = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/mime/config'
    })
};

// 添加mime配置
export const addMimeConfig = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/mime/add',
        data
    })
};

// 删除mime配置
export const removeMimeConfig = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/mime/remove',
        data
    })
};

// 获取404页面文件
export const queryErrorPageFiles = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/errorPage/fileList',
        data
    })
};

// 设置404页面
export const setErrorPage = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/errorPage/set',
        data
    })
};

// 重置404页面
export const unsetErrorPage = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/errorPage/unset'
    })
};

// 获取301配置
export const queryRedirectConfig = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/redirect/config'
    })
};

// 添加301页面
export const setRedirectConfig = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/redirect/add',
        data
    })
};

// 删除301页面
export const delRedirectConfig = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/redirect/del',
        data
    })
};


// php错误日志参数(error_log)设置
export const setPhpErrorLog = (flag) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/errorLog/${flag}`,
    })
};

// php输出缓冲区数据块设置
export const setPhpOb = (flag) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/ob/${flag}`,
    })
};

// php上传文件开关控制
export const setPhpUpload = (flag) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/upload/${flag}`,
    })
};

// PHP上传文件最大限制
export const setPhpMaxUploadSize = (webQuota) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/maxUploadSize/${webQuota}`,
    })
};

// PHP函数chown设置和PHP函数fsockopen设置
export const setPhpDisableFuncs = (funcs) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/disableFuncs/${funcs}`,
    })
};

// PHP启用状态设置
export const setPhpLang = (version, flag) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/lang/${version}/${flag}`,
    })
};

// PHP变更版本
export const setPhpChangeVersion = (version) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/changeVersion/${version}`,
    })
};


// .NET信任级别设置
export const setDotnetTrustedLevel = (level) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/dotnet/trustedLevel/${level}`,
    })
};

// .NET变更版本
export const setDotnetChangeVersion = (version, mode) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/dotnet/changeVersion/${version}/${mode}`,
    })
};

// 脚本错误信息
export const setDotnetScriptError = ({ notify = '', msg = '' } = {}) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/dotnet/scriptError/${notify}`,
        data: { msg },
    })
};


// 设置默认首页
export const setDefaultHomePage = (data) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/setDefaultHomePage`,
        data,
    })
};
// 

// 更新PHP参数
export const updatePhpParam = (data) => {
    return axios.request({
        method: "POST",
        useAbort: true,
        url: `/api/vhost/config/php/updatePhpParam`,
        data,
    })
};

// 获取PHP错误级别列表
export const getPhpErrorPort = () => {
    return axios.request({
        method: "get",
        useAbort: true,
        url: `/api/vhost/config/php/getPhpErrorPort`,
    })
};

// 获取PHP时区
export const getPhpTimeZone = () => {
    return axios.request({
        method: "get",
        useAbort: true,
        url: `/api/vhost/config/php/getPhpTimeZone`,
    })
};